export function useUi() {
  return {
    closeContainer() {
      /* TODO: а надо ли что-то делать? */
    },
  };
}
